import { forwardRef } from 'react';
import {
  Box,
  CircularProgress,
  Fab as MuiFab,
  FabProps as MuiFabProps,
  Tooltip,
  TooltipProps,
} from '@mui/material';

import { Icon, IconOption } from '@components/base';

export type FabProps = MuiFabProps & {
  icon: IconOption;
  loading?: boolean;
  TooltipProps?: Omit<TooltipProps, 'children' | 'title'>;
};

export const Fab = forwardRef<HTMLButtonElement, FabProps>(
  ({ icon, loading, title, disabled, TooltipProps: tooltipProps, ...rest }, ref) => (
    <Box position='relative'>
      <Tooltip title={title} {...tooltipProps}>
        <MuiFab disabled={disabled || loading} ref={ref} size='small' {...rest}>
          <Icon fontSize='small' name={icon} />
        </MuiFab>
      </Tooltip>

      {loading && (
        <Box position='absolute' top={0}>
          <CircularProgress color='primary' size={32} />
        </Box>
      )}
    </Box>
  )
);
